import { useFilters } from './useFilters';
import { usePagination } from './usePagination';
import { SortOrder } from 'further-types/utils';

export function usePaginatedFilters<
  T extends Record<string, unknown>,
  U extends string,
>(
  pageId: string,
  {
    defaultFilters,
    defaultOrder,
    orderByOptions,
  }: {
    defaultFilters: T;
    defaultOrder: {
      orderBy: U;
      order: SortOrder;
    };
    orderByOptions?: readonly [U, ...Array<U>];
  },
) {
  const pagination = usePagination<U>(
    {
      orderBy: defaultOrder.orderBy,
      order: defaultOrder.order,
      id: pageId,
    },
    orderByOptions,
  );

  const { filters, handleChangeFilters, isFiltersChangePending } = useFilters(
    pageId,
    {
      defaultFilters,
      onFiltersChange: pagination.toFirstPage,
    },
  );

  return {
    filters,
    handleChangeFilters,
    pagination,
    isFiltersChangePending,
  };
}
